export default function Unauthorized() {
    return (
        <div className="flex flex-col items-center justify-center h-screen text-red-500 text-3xl">
            
            Access Denied – Super Admin Only
        </div>
    );
}
